import "./App.css";
import { ethers } from "ethers";
import { useState, useEffect } from "react";
import { useEffectOnce } from "./effectonce.js";

function App() {
  const [clockList, setClocklist] = useState([]);

  var apiKey = "CwU_HrxG-JzrNQtPymA6zgjMUyWjUFg5";
  var provider = new ethers.providers.JsonRpcProvider(`https://eth-mainnet.g.alchemy.com/v2/${apiKey}`);
  var hello = "stuf here";
  const timezone4Address = "0x832a2a8f1f1397a63bf4209c0a3d637acc50fcb6";
  const timezoneAbi = [
    "function name() view returns (string)",
    "function tokenURI(uint256 tokenId) view returns (string)",
  ];
  const timezone4Contract = new ethers.Contract(
    timezone4Address,
    timezoneAbi,
    provider
  );

  useEffectOnce(() => {
    const fetchData = async (tokennumber) => {
      const theJson = await timezone4Contract.tokenURI(tokennumber);
      const metaWithoutDataURL = theJson.substring(theJson.indexOf(",") + 1);
      const parsedMeta = JSON.parse(metaWithoutDataURL)["image"];
      setClocklist((clockList) => [...clockList, parsedMeta]);
    };
    for (var n = 1; n < 29; n++) {
      fetchData(n);
    }
  }, []);

  const listItems = clockList.map((clock) => (
    <div className="singleClock">
      <img
        src={`data:image/svg+xml;base64,${btoa(clock)}`}
        alt=""
        width="200"
        height="200"
      />
    </div>
  ));

  //console.log(clockList.length);
  //console.log(clockList[0]);
  // var jsontest = await timezone4Contract.tokenURI(1);
  // console.log(jsontest)
  return (
    <div className="App">
      <header className="App-header">{listItems}</header>
    </div>
  );
}

export default App;
